module.exports = __webpack_public_path__ + "static/media/Pluxee_Logo_DarkBlue_RGB.f0a83a75.png";